import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../class/auth';
import { environment } from '../../../environments/environment';

declare var $:any;
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})

export class ProfileComponent implements OnInit {
  preurl :string = '';
  nickname :string = '';
  phone :string = '';
  oldpwd :string = '';
  repwd :string = '';
  newpwd :string = '';
  toasts_itme:any = [];
  showphonemsg:boolean = false;
  loading:boolean = false;
  $:any
  constructor(public httpClient: HttpClient,) {}

  ngOnInit(): void {
    this.preurl = environment.serverurl;
    this.init_profile();
  }

  update_pwd(){
    if(this.repwd.length==0||this.newpwd.length==0||this.oldpwd.length==0){
      this.show_toasts('請正確輸入您的密碼');
    }else{
      if(this.newpwd !=this.repwd ){
        this.show_toasts('確認密碼輸入不一致');
      }else{
        const body = {token:Dep.token,type:2,newpwd:this.newpwd,oldpwd:this.oldpwd};
        this.update_info(body);
      }
    }
  }



  update_profile(){
    const body = {token:Dep.token,type:1,nickname:this.nickname,phone:this.phone};
    this.update_info(body);
  }

  show_toasts(content:string,title:string='系統訊息'){
    this.toasts_itme = {title:title,content:content}
    $('.toast').toast('show');
  }

  style_back():any{
    const obj = {'position':'absolute','right':'1px','top':'0x'};
    return obj;

  }

  check_formate(){
    var re = new RegExp(/^0{0,1}9[0-9]{2}-{0,1}[0-9]{6}$/);
    if(re.test(this.phone)){
      this.showphonemsg = false;
    }else{
      this.showphonemsg = true;
    }
  }

  init_profile(){
    const body = {token:Dep.token};
    this.loading = true;

    this.httpClient.post<any>("/get_emp_file.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.nickname = res.user.nickname;
        this.phone = res.user.phone;
      }else{
        Dep.faild(res);
      }
    }, error => {
      console.log(error);
    });
  }

  update_info(body:any){
    this.loading = true;
    this.httpClient.post<any>("/update_emp_profile.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        Dep.setData(res.token);
      }else{
        Dep.faild(res);
        this.show_toasts(res.message);
      }     
    }, error => {
      console.log(error);
    });
  }
}
